module.exports = __webpack_public_path__ + "61607e6d00fe2ade27468352e8302e25.pdf";